import { createFileRoute } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { Footer } from "@/components/Footer/Footer";
import { IconHeadphones, IconWhatsApp } from "@/components/Icons";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import { WHATSAPP_URL } from "@/utils/constants";

export const Route = createFileRoute("/_authenticated/chat")({
  component: RouteComponent,
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <main className="main flex flex-col items-center justify-center p-4">
      <div className="mb-[calc((var(--main-bottom-padding)+var(--footer-height))/2)] flex flex-col items-center rounded-2xl bg-white p-4 text-center shadow-sm">
        <IconHeadphones className="mb-4 size-29 bg-radial-[closest-side] from-surface-accent-soft p-4" />

        <h2 className="text-xl font-medium text-text-title">
          {intl.formatMessage({
            defaultMessage: "Need help finding the right trip?",
            description: "chat.widget.title",
          })}
        </h2>
        <div className="mt-2 text-sm text-text-placeholder">
          {intl.formatMessage({
            defaultMessage:
              "Our team can help you book the best options directly",
            description: "chat.widget.description",
          })}
        </div>

        <div className="mt-4 w-full">
          <Button
            onClick={() => {
              rudderAnalytics.track(
                CommonTrackingEvents.USER_CONTACTED_SUPPORT,
              );
            }}
            href={WHATSAPP_URL}
            variant="contained"
            borderRoundness="medium"
            color="whatsapp"
            fullWidth
            startIcon={<IconWhatsApp className="size-5" />}
          >
            {intl.formatMessage({
              defaultMessage: "Chat on WhatsApp",
              description: "chat.widget.button",
            })}
          </Button>
        </div>
      </div>

      <Footer />
    </main>
  );
}
